module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "udYgOh9fadslS6oSOhKUdZF"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_c('a', {
    attrs: {
      "id": "uCMMWJRgaFtXri5RnWG9PO9"
    }
  }), _vm._v("ANGELO BUONO")]), _c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v(" &")]), _c('span', {
    staticClass: "Bold"
  }, [_vm._v(" KENNETH BIANCHI ")]), _c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("“The Hillside Stranglers”")]), _vm._v(" "), _c('span', {
    staticClass: "Kill-Count"
  }, [_vm._v("10 Kills/12 Kills")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("BUONO DOB: 10/05/1934 NY DOD: 9/21/2002 CA (age 69)")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("DIED IN HIS CELL FROM A HEART ATTACK")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("---")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("BIANCHI DOB: 5/22/1951 NY")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("SENTENCE: LIFE WITH CHANCE OF PAROLE")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("Facility: Washington State Penitentiary, Walla Walla, WA INMATE 266962")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("THE CRIME: ")]), _vm._v("From 10/17/1977 until 2/16/1978, the two cousins, related by adoption, raped and strangled to death 10 females in the Los Angeles area, then dumped their nude bodies alongside deserted highway embankments or in isolated locations. Some of the victims showed signs of torture and some were sodomized. Buono and Bianchi pretended to be police officers to lure most of their unsuspecting and naïve victims. The murdered ranged in age from 12 to 28.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("THE CAPTURE:")]), _vm._v(" Bianchi and Buono separated at Buono’s request to avoid detection. He was worried that Bianchi was becoming too careless. Bianchi moved to Bellingham, WA and was hired as a security guard. However, he was quickly arrested for the rape and murder of two women there. Bianchi agreed to plead guilty and testify against Buono in exchange for leniency after his failed attempt to claim insanity.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("BACKGROUND: Angelo Anthony Buono, Jr.")]), _vm._v(" exhibited an unusually high level of interest in anything of a sexual nature from an early age. He bragged to peers that he had raped several girls and idolized serial rapist, Caryl Chessman, “The Red Light Bandit”, but faulted his hero for not killing his victims. At 17, he wed his pregnant girlfriend, but left her before their son was born and refused to financially support the child. He fathered five children by his second wife and two children by his third wife. Both women claimed he sexually molested one of their daughters. He married a fourth time in prison before his death but was not allowed conjugal visits.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Buono would have most likely remained a low-life, low-key offender if he had not met Kenneth Bianchi in 1975.Together the two became an evil force sustained and fueled by one another. On 10/17/1977, 43-year-old Buono and 26-year-old Bianchi killed their first victim. The sexually sadistic and psychopathic duo, working in concert, abducted, raped, and strangled to death their first victim, a 19-year-old waitress and prostitute they felt cheated them out of money.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("Kenneth Alessio Bianchi")]), _vm._v(" was adopted after his birth mother, a teen-age alcoholic and prostitute, placed him for adoption shortly after birth. He never knew the identity of his biological father. Bianchi was raised in a middle class, two parent home as an only child. From the beginning, he showed signs of psychiatric problems. His adopted mother once complained that Bianchi started telling lies the same day he started to talk and remained a compulsive liar his entire life. At age 5, he was diagnosed with petit mal seizures, causing the young child to briefly lose consciousness. He was a bed wetter and was diagnosed with a passive-aggressive personality disorder by age 10. He often had violent and uncontrollable tantrums in school by age 11.")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("OUT OF THE MOUTH OF THE SERIAL KILLER:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("“Was it wrong to get rid of some fuckin’ cunts?” ")]), _vm._v("Kenneth Bianchi")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("(At Bianchi’s sentencing in 10/1979:)"), _c('span', {
    staticClass: "Bold"
  }), _c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("“To even begin to try to live with myself, I have to take responsibility for what I’ve done and I have to do everything I can to get into the modem and to devote my entire life, to do everything I possibly can to give my life so that nobody else will hopefully follow in, will hopefully won’t follow in my footsteps.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("(Kenneth Bianchi interviewed "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("after ")]), _vm._v("he was tried, sentenced, and serving time, claiming no memory of any crime:)"), _c('span', {
    staticClass: "italics"
  }), _c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("“I really have no memory of having murdered anybody. Even to satisfy other persons’ allegations at one time. I attempted to think about what it might feel like and I have never been able to do that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("When Kenneth Bianchi was asked if he could live his life over, what would he change:"), _c('span', {
    staticClass: "Bold"
  }), _c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("“I really wouldn’t change anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("Additional Facts:")])]), _vm._v(" "), _c('p', {
    staticClass: "Quote-Letters"
  }, [_vm._v("• Bianchi pled NGRI (Not Guilty by Reason of Insanity), claiming he had another personality named Steven Walker who had committed the crimes. His claims were debunked and he eventually admitted to faking the disorder.")]), _vm._v(" "), _c('p', {
    staticClass: "Quote-Letters"
  }, [_vm._v("• Victoria Compton was 24-years-old when she fell in love with the incarcerated Kenneth Bianchi. She planned a copycat killing to get Bianchi out of jail but was caught and sentenced in 1981 for attempted murder. "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("“There I was with the Manson women and Carol Bundy. All I could think was, what the hell have I done? This isn’t me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Quote-Letters"
  }, [_vm._v("• Victoria Compton escaped from jail in 1988 but was caught 10 days later. She was released on parole in 1996, but that parole was quickly revoked after she failed to comply with its terms. She has since been released from jail.")]), _vm._v(" "), _c('p', {
    staticClass: "Quote-Letters"
  }, [_vm._v("• Bianchi’s sperm that was to be used in the murder by Compton was concealed in a plastic glove and passed to her during a jailhouse visit, hidden in the binding of a book.")]), _vm._v(" "), _c('p', {
    staticClass: "Quote-Letters"
  }, [_vm._v("• On 8/27/1989, while incarcerated, 33-year-old Victoria Compton married 60-year-old James P. Wallace, a retired professor. Their daughter was born while Compton was in jail.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b307458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/OoM_003.vue
// module id = 90
// module chunks = 0